<template>
  <div>
    <!-- BLUE Header -->
    <div class="header">
      <el-row>
        <el-col :span="20" :offset="2">
          <h1>Administración de días de entrega (máximo)</h1>
        </el-col>
      </el-row>
    </div>
    <!-- END BLUE Header -->

    <el-row>
      <el-col :span="20" :offset="2">
        <el-card class="box-card">
          <el-table :data="deliveryData" style="width: 100%" stripe>
            <el-table-column
              label="Valor actual de delivery days"
              align="center"
            >
              <template slot-scope="props">
                <h4>
                  <i class="el-icon-user"></i>
                  {{ props.row }}
                </h4>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="20" :offset="2">
        <el-card class="box-card">
          <h2>Actualizar delivery-days</h2>
          <el-form :model="form" ref="updateForm" label-width="120px">
            <el-form-item label="Nuevo valor">
              <el-input-number
                v-model="newDeliveryDays"
                auto-complete="off"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="[Autorización]">
              <el-input
                v-model="password"
                show-password
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="updateDeliveryDays"
                >Actualizar</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <br />
  </div>
</template>

<script>
import DialogUser from "@/components/DialogUser";
import { CSApi } from "@/libraries/api";

export default {
  name: "DeliveryDays",
  components: {
    DialogUser,
  },
  data() {
    return {
      deliveryData: [],
      newDeliveryDays: "",
      password: "",
    };
  },
  methods: {
    async loadData() {
      try {
        const deliveryDaysResponse = await CSApi().get(
          "/coverage/delivery-days"
        );
        this.deliveryData = [deliveryDaysResponse.data.data.days];
      } catch (error) {
        console.log(error.response);

        this.$message({
          message: error,
          type: "error",
          duration: 8000,
        });
      }
    },
    async updateDeliveryDays() {
      try {
        const response = await CSApi().post(
          "/coverage/delivery-days",
          { days: Number(this.newDeliveryDays) },
          {
            headers: { "coverage-password": this.password },
          }
        );

        if (!response.data.success) {
          this.$message({
            message: response.data.data.error.message,
            type: "error",
            duration: 8000,
          });
          return;
        }

        this.deliveryData = [this.newDeliveryDays];

        this.newDeliveryDays = "";

        this.password = "";

        this.$message({
          message: "Delivery-days updated",
          type: "success",
          duration: 5000,
        });
      } catch (error) {
        console.log(error.response);

        this.$message({
          message: error,
          type: "error",
          duration: 8000,
        });
      }
    },
  },
  async mounted() {
    await this.loadData();
  },
};
</script>

<style scoped>
.el-timeline {
  overflow-y: auto;
  height: 100vh;
  padding-top: 20px;
}

.change-item {
  margin-bottom: 2px;
  margin-top: 2px;
}

pre {
  margin: 0px 30px;
}
</style>
